import { useState, useCallback, useEffect } from 'react'

import { sortTableByKey } from '../utils'
import {
  sortDirectionConstant,
  TOTAL_ID_PREFIX,
} from 'constants/tableConstants'

const separateDataAndTotal = (data = []) => {
  if (Array.isArray(data)) {
    return data.reduce(
      (res, item) => {
        if (item?.id?.includes(TOTAL_ID_PREFIX)) {
          res.totalRowField = item
        } else {
          res.dataWithoutTotalItem.push(item)
        }
        return res
      },
      {
        totalRowField: null,
        dataWithoutTotalItem: [],
      }
    )
  }
  return data
}

export const useSort = (
  data,
  defaultSortField,
  defaultDirection = sortDirectionConstant.ASC
) => {
  const [sortData, setSortData] = useState(() => {
    const { totalRowField, dataWithoutTotalItem } = separateDataAndTotal(data)

    if (totalRowField)
      return [
        totalRowField,
        ...sortTableByKey(
          dataWithoutTotalItem,
          [defaultSortField],
          [defaultDirection]
        ),
      ]

    return sortTableByKey(data, [defaultSortField], [defaultDirection])
  })

  const [sortParams, setSortParams] = useState({
    field: defaultSortField,
    direction: defaultDirection,
  })

  const handleSortClick = useCallback(
    (sortField, sortDirection) => {
      setSortParams({
        field: sortField,
        direction: sortDirection,
      })

      const { totalRowField, dataWithoutTotalItem } = separateDataAndTotal(data)
      if (totalRowField) {
        setSortData([
          totalRowField,
          ...sortTableByKey(dataWithoutTotalItem, [sortField], [sortDirection]),
        ])
      } else {
        setSortData(sortTableByKey(data, [sortField], [sortDirection]))
      }
    },

    [data]
  )

  useEffect(() => {
    const { totalRowField, dataWithoutTotalItem } = separateDataAndTotal(data)

    if (totalRowField) {
      setSortData([
        totalRowField,
        ...sortTableByKey(
          dataWithoutTotalItem,
          [sortParams.field],
          [sortParams.direction]
        ),
      ])
    } else {
      setSortData(
        sortTableByKey(data, [sortParams.field], [sortParams.direction])
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return [sortData, sortParams.field, sortParams.direction, handleSortClick]
}
